import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { DallasPin } from "../../../app-constants";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "How can TekRevol help me with software development in Dallas?",
    answer: ` <p>We can help you define your business goals and create user personas, mockups, core features, and a strategic roadmap for project deliverables and timelines. We’ll happily outline your project specification and prepare wireframes and details concerning integrations with external services, API documentation, and the entire backend, front-end, and server-side architecture.</p>`,
  },
  {
    question:
      "Should I be familiar with the technical details to start working with you?",
    answer: `<p>No, acknowledging and starting work on all the technical details is on us. Once we’re done discussing your business goals, project scope, timelines, and deliverables, we’ll educate you regarding the tech stack, tools, and frameworks we’ll use to develop your product.</p>`,
  },
  {
    question:
      "Do you provide product support services after the software development completion?",
    answer: `<p>Yes, we offer technical support and app maintenance should you need it. We’ll conduct a post-launch analysis to ensure your app’s performance, functionality, and usability are flawless without affecting user experience in any way.</p>
        <p>Moreover, we’ll also acquire the users’ feedback and use the insights to incorporate updated features and updates for the next iteration.</p>`,
  },
  {
    question:
      "Do I need an iOS app or an Android app? Which platform is better to start with?",
    answer: `<p>The platform you choose depends on your project scope and business goals. For instance, if you wish to monetize your application, you may choose iOS, as Apple users are more inclined to pay for app downloads and in-app purchases.</p>
        <p>If you wish to register more downloads, Android would be a better choice, as Android users aren’t exactly happy to pay for app installations and prefer free downloads.</p>`,
  },
  {
    question: "Why hire a custom software development company in Dallas?",
    answer: `<p>The Dallas region is speedily transforming by acquiring the latest technologies for business digitization. Every other business is enhancing its online presence with mobile app solutions. So, it's the right time for your business to create custom software that will help you automate your business operations while increasing overall productivity. For that purpose, you consult with a reliable custom software development company in Dallas and revolutionize your business with result-oriented digitization.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col xs={12} md={12} lg={8} xl={7} xxl={7} className="services_faqs">
            <FaqComponents faqs={faqs} />
          </Col>

          <Col xs={12} md={12} lg={4} xl={4} xxl={4} className="offset-xl-1">
            <div className="map_loc">{DallasPin}</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
